import { Stack } from '@mui/material';
import ExportButton from './ExportButton';
import ImportButton from './ImportButton';

export default function Buttons({
	rows,
	localChannels,
	channelKeys,
	setLocalChannels,
	handleSentData,
}) {
	return (
		<Stack
			direction="row"
			justifyContent={'flex-end'}
			spacing={2}
			sx={{ height: 'auto' }}
		>
			<ExportButton channelKeys={channelKeys} />
			<ImportButton
				localChannels={localChannels}
				channelKeys={channelKeys}
				setLocalChannels={setLocalChannels}
				handleSentData={handleSentData}
			/>
		</Stack>
	);
}
